const RICH_POST_TAG =
	/<(?:a|p|br|strong|b|em|i|u|s|ul|ol|li|h[1-3]|blockquote|div|img|pre|code)\b/i;

export const isRichPostContent = (text: string): boolean =>
	RICH_POST_TAG.test(text);
